import api from "./api";

const vendorProfileService = {
  // Get all vendor profiles with filtering and pagination
  getAllVendorProfiles: async (params = {}) => {
    try {
      const response = await api.get("/api/vendor-profiles", { params });
      return response.data.data || response.data;
    } catch (error) {
      console.log(
        "Vendor Profiles API failed, using mock data:",
        error.message
      );
      // Return empty array structure when API fails
      return {
        vendorProfiles: [],
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        stats: null
      };
    }
  },

  // Get vendor profile statistics
  getVendorProfileStats: async () => {
    const response = await api.get("/api/vendor-profiles/stats");
    return response.data.data || response.data;
  },

  // Get vendor profile by ID
  getVendorProfileById: async (id) => {
    const response = await api.get(`/api/vendor-profiles/${id}`);
    return response.data.data || response.data;
  },

  // Get vendor profile by user ID
  getVendorProfileByUserId: async (userId) => {
    const response = await api.get(`/api/vendor-profiles/user/${userId}`);
    return response.data.data || response.data;
  },

  // Create new vendor profile
  createVendorProfile: async (vendorProfileData) => {
    const response = await api.post("/api/vendor-profiles", vendorProfileData);
    return response.data.data || response.data;
  },

  // Update vendor profile
  updateVendorProfile: async (id, vendorProfileData) => {
    const response = await api.put(
      `/api/vendor-profiles/${id}`,
      vendorProfileData
    );
    return response.data.data || response.data;
  },

  // Delete vendor profile
  deleteVendorProfile: async (id) => {
    const response = await api.delete(`/api/vendor-profiles/${id}`);
    return response.data.data || response.data;
  },

  // Approve vendor profile
  approveVendorProfile: async (id) => {
    const response = await api.patch(`/api/vendor-profiles/${id}/approve`);
    return response.data.data || response.data;
  },

  // Reject vendor profile
  rejectVendorProfile: async (id) => {
    const response = await api.patch(`/api/vendor-profiles/${id}/reject`);
    return response.data.data || response.data;
  },
};

export default vendorProfileService;
